var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 6.71252 2.5 5.06878 3.40796 3.96243C3.57418 3.75989 3.75989 3.57418 3.96243 3.40796C5.06878 2.5 6.71252 2.5 10 2.5V2.5C13.2875 2.5 14.9312 2.5 16.0376 3.40796C16.2401 3.57418 16.4258 3.75989 16.592 3.96243C17.5 5.06878 17.5 6.71252 17.5 10V10C17.5 13.2875 17.5 14.9312 16.592 16.0376C16.4258 16.2401 16.2401 16.4258 16.0376 16.592C14.9312 17.5 13.2875 17.5 10 17.5V17.5C6.71252 17.5 5.06878 17.5 3.96243 16.592C3.75989 16.4258 3.57418 16.2401 3.40796 16.0376C2.5 14.9312 2.5 13.2875 2.5 10V10Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66663L10 13.3333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10L6.66659 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/add_button.4d3f8d0597e8bba7e6564bb9a3aad173.svg";
export { ForwardRef as ReactComponent };